/*=========================================================================================
  File Name: moduleTodoMutations.js
  Description: Todo Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
==========================================================================================*/


export default {
  ADD_TO_ENDORSEMENT_INVITE_EMAIL_LIST (state, email) {
    state.emailList.push(email)
  },
  REMOVE_FROM_ENDORSEMENT_INVITE_EMAIL_LIST (state, email) {
    const emailIndex = state.emailList.findIndex(ch => ch === email)
    state.emailList.splice(emailIndex, 1)
  },
  ADD_PROGRESS_MEASURE (state, progressMeasure) {
    state.progressMeasures.push(progressMeasure)
  },
  REMOVE_PROGRESS_MEASURE (state, progressMeasure) {
    const pmIndex = state.progressMeasures.findIndex(pm => pm === progressMeasure)
    state.progressMeasures.splice(pmIndex, 1)
  },
  ADD_EXTERNAL_FEEDBACK (state, gapObj) {
    // state.externalFeedback.push(gapObj)
    // const gapIndex = state.externalFeedback.findIndex(ch => ch === email)
    state.externalFeedback.splice(gapObj.index, 1)
    state.externalFeedback.splice(gapObj.index, 0, gapObj);
  },
  UPDATE_CHART_OBJ (state, chartObj) {
    state.chartObj = chartObj
  },
  DESTROY_EMAIL_LIST(state) {
    state.emailList = []
  },
  DESTROY_PROGRESS_MEASURES(state) {
    state.progressMeasures = []
  },
  DESTROY_EXTERNAL_FEEDBACK(state) {
    state.xternalFeedback = []
  },
  DESTROY_CHART_OBJ(state) {
    state.chartObj = {}
  }
}
